import { Card, type CardProps } from '@common/ui/Card';
import { Heading } from '@common/ui/typography/Heading';
import { Paragraph } from '@common/ui/typography/Paragraph';

export type SectionCardProps = CardProps & {
  title: string;
  description: string;
};

export const SectionCard = ({
  title,
  description,
  ...props
}: SectionCardProps) => {
  return (
    <Card {...props}>
      <Heading level={3} noPadding>
        {title}
      </Heading>
      <Paragraph variant="secondary" noPadding>
        {description}
      </Paragraph>
      {props.children}
    </Card>
  );
};
